export class PoolTruck {
    timestamp: string;
    number: string;
    name: string;
    registrationNumber: string;
    createdBy: string;
    creationDateTime: string;
    lastModifiedBy: string;
    lastModificationDateTime: string;

    constructor() {
        this.timestamp = "";
        this.number = "";
        this.name = "";
        this.createdBy = "";
        this.creationDateTime = "";
        this.lastModifiedBy = "";
        this.lastModificationDateTime = "";
    }
}